<span *ngIf="company$ | async as company" wizHeadTitle i18n
  >{{ company.name }} - recrutement, stage et alternance | WIZBII</span
>

<ng-container *ngIf="(isLogged$ | async) === false">
  <span *ngIf="company$ | async as company" wizHeadDescription i18n>
    {{ company.name }}
    recrute de jeunes talents sur WIZBII. Postulez en un clic aux offres d'emploi, de stage et d'alternance !
  </span>
</ng-container>

<app-header
  [applicationsTotal]="applicationsTotal$ | async"
  [bookmarksTotal]="(bookmarkMap$ | async)?.size"
  [profile]="profile$ | async"
  [isLogged]="isLogged$ | async"
></app-header>

<app-header-banner></app-header-banner>

<main *ngIf="company$ | async" class="company-main container">
  <div class="company-main__header">
    <company-header
      [company]="company$ | async"
      (followEmitter)="follow($event)"
      (unfollowEmitter)="unfollow($event)"
    ></company-header>
  </div>

  <div class="company-main__outlet">
    <app-tab-bar>
      <app-link
        *ngIf="(company$ | async)?.presentationTab?.description.trim() !== ''"
        [path]="basePath"
        [exact]="true"
        i18n-label
        label="Présentation"
      ></app-link>

      <app-link
        *ngIf="totalCompanyJobs$ | async as totalCompanyJobs"
        [path]="basePath"
        [fragment]="companyRoutingFragmentEnum.Jobs"
        i18n-label
        label="Jobs"
        [notificationContent]="totalCompanyJobs"
      ></app-link>

      <app-link
        *ngIf="(company$ | async)?.partnersActivated && (totalPartnersJobs$ | async) as totalPartnersJobs"
        [path]="basePath"
        [fragment]="companyRoutingFragmentEnum.PartnersJobs"
        i18n-label
        label="Jobs des partenaires"
        [notificationContent]="totalPartnersJobs"
      ></app-link>

      <app-link
        *ngIf="(publications$ | async)?.length > 0"
        [path]="basePath"
        [fragment]="companyRoutingFragmentEnum.News"
        i18n-label
        label="Actualités"
      ></app-link>

      <ng-container *ngFor="let customTab of (company$ | async)?.customTabs; trackBy: trackById">
        <app-link
          *ngIf="displayCustomTab(profile$ | async, customTab)"
          [path]="basePath"
          [fragment]="customTab.id"
          [label]="customTab.title"
          i18n-label
        ></app-link>
      </ng-container>
    </app-tab-bar>

    <router-fragment-outlet
      #routerFragment
      [basePath]="basePath"
      [baseFragment]="''"
      [navigateBase]="!cannotDisplayCompany(company$ | async, isLogged$ | async)"
    >
      <router-fragment
        *ngIf="(company$ | async)?.presentationTab?.description.trim() !== ''"
        [active]="routerFragment.active"
        [fragment]="''"
      >
        <company-presentation [company]="company$ | async"></company-presentation>
      </router-fragment>

      <router-fragment
        *ngIf="(totalCompanyJobs$ | async) > 0"
        [active]="routerFragment.active"
        [fragment]="companyRoutingFragmentEnum.Jobs"
        ><company-jobs></company-jobs
      ></router-fragment>

      <router-fragment
        *ngIf="(company$ | async)?.partnersActivated && (totalPartnersJobs$ | async) > 0"
        [active]="routerFragment.active"
        [fragment]="companyRoutingFragmentEnum.PartnersJobs"
        ><company-partners-jobs></company-partners-jobs
      ></router-fragment>

      <router-fragment
        *ngIf="(publications$ | async)?.length > 0"
        [active]="routerFragment.active"
        [fragment]="companyRoutingFragmentEnum.News"
      >
        <company-news [company]="company$ | async"></company-news>
      </router-fragment>

      <ng-container *ngFor="let customTab of (company$ | async)?.customTabs; trackBy: trackById">
        <router-fragment
          *ngIf="displayCustomTab(profile$ | async, customTab)"
          [active]="routerFragment.active"
          [fragment]="customTab.id"
        >
          <company-custom
            [company]="company$ | async"
            [profile]="profile$ | async"
            [fragment]="customTab.id"
          ></company-custom>
        </router-fragment>
      </ng-container>
    </router-fragment-outlet>
  </div>
</main>

<app-footer [isLogged]="isLogged$ | async"></app-footer>
<app-social-icons></app-social-icons>
